<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_gate.edit') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="gate.name" :label="$t('edit_gate.name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="gate.warehouse.id" :items="warehouses" :label="$t('edit_gate.warehouse')" item-text="name" item-value="id" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('edit_gate.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'gate.update'">
                                {{ $t('edit_gate.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>   
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { indexWarehousesUseCase } from "../../warehouses/application/use_cases/index_warehouse_use_case";
import { HttpWarehouseRepository } from "../../warehouses/infrastructure/repositories/warehouse_repository";
import { showGateUseCase } from "../application/use_cases/show_gate_use_case";
import { updateGateUseCase } from "../application/use_cases/update_gate_use_case";
import { HttpGateRepository } from "../infrastructure/repositories/gate_repository";

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            gate:{
                name: '',
                gate_id: '',
                is_rfid: false,
                is_entry: false,
                warehouse: {
                    id: '',
                    name: ''
                }
            },
            warehouses: []
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.edit_gate";
    },
    methods: {
        async index(){
            this.gate = await showGateUseCase(this.id, HttpGateRepository);
            this.warehouses = await indexWarehousesUseCase(HttpWarehouseRepository)
        },
        async save(){
            try {
                this.gate.warehouse_id = this.gate.warehouse.id;
                const response = await updateGateUseCase(this.id, this.gate, HttpGateRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: response.data.success.message
                }
                
                this.$router.go(-1);  
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
    }
}
</script>

<style lang="css">
</style>